/*!
 * quake-watch.js — «сообщить, если тряхнёт рядом» на /earthquake-map.
 *
 * ЧТО ЭТО. Подписка на ТОЧКУ: координата, радиус, порог магнитуды и отдельный
 * выключатель цунами. Письма шлёт крон `quakes:notify`; здесь только запись,
 * список и удаление.
 *
 * ⚠️⚠️ ЧЕСТНАЯ РАМКА. Письмо НЕ ОБГОНИТ ТРЯСКУ: волны идут 3–8 км/с, событие
 * попадает в фид через минуты, почта идёт ещё минуты. Поэтому строка
 * `watch_not_a_warning` печатается ВСЕГДА и не зависит ни от состояния
 * подписки, ни от тарифа. Убрать её «чтобы не пугать» — значит начать обещать
 * то, чего функция физически не может.
 *
 * ⚠️ Блок показывается ВСЕМ, включая гостей и бесплатные аккаунты, но кнопка у
 * них ведёт в Премиум, а не притворяется рабочей: перк, которого не видно,
 * ничего не продаёт (тот же приём, что у слежки за сертификатами).
 */
(function () {
    'use strict';

    var C = window.QUAKE_CFG || {};
    var T = C.t || {};
    var API = (C.api && C.api.watch) || '/api/quake-watch';
    var tr = function (k) { return T[k] != null ? T[k] : k; };
    var $ = function (id) { return document.getElementById(id); };
    var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };

    var esc = function (s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    };

    var root = $('qkWatch');
    if (!root) return;

    var picked = null;          // {lat, lng, place}
    /* `authed` — от сервера при рендере (QUAKE_CFG.authed), а не «false, пока
     * fetch не ответил»: тот же класс, что у /voice-cover 09.09.2026 — упавший
     * или медленный запрос делал из вошедшего гостя и слал его в /login. */
    /* Кука входа старше любой разметки: разметка может быть копией из кэша
       Service Worker'а, кука — нет (см. __signedIn в timbrica-core.js). */
    var state = { premium: false, max: 5, watches: [],
                  authed: C.authed === true || (typeof window.__signedIn === 'function' && window.__signedIn()) };

    /* ── Список подписок ───────────────────────────────────────────────── */

    function csrf() {
        var m = document.querySelector('meta[name="csrf-token"]');
        return m ? m.getAttribute('content') : '';
    }

    function load() {
        fetch(API, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) {
                // 401 — это гость, а не поломка: блок остаётся видимым.
                if (r.status === 401) { state.authed = false; return null; }
                state.authed = true;
                return r.ok ? r.json() : null;
            })
            .then(function (d) {
                if (d) {
                    state.premium = !!d.premium;
                    state.max = d.max || 5;
                    state.watches = d.watches || [];
                }
                render();
            })
            .catch(render);
    }

    function render() {
        var list = $('qkWList'), note = $('qkWNote');
        if (!list) return;

        list.innerHTML = state.watches.map(function (w) {
            var sub = 'M' + Number(w.min_magnitude).toFixed(1) + '+ · ' + w.radius_km + ' ' + tr('km')
                + (w.notify_tsunami ? ' · ' + tr('watch_tsunami_short') : '');
            return '<li><span><b>' + esc(w.place) + '</b><small>' + esc(sub) + '</small></span>'
                 + '<button type="button" data-del="' + w.id + '">' + esc(tr('watch_remove')) + '</button></li>';
        }).join('');

        if (!note) return;
        if (!state.authed) {
            note.innerHTML = esc(tr('watch_login'));
        } else if (!state.premium) {
            note.innerHTML = esc(tr('watch_premium')) + ' <a href="' + esc(premiumUrl()) + '">'
                           + esc(tr('watch_premium_cta')) + '</a>';
        } else if (state.watches.length >= state.max) {
            note.textContent = tr('watch_limit').replace(':max', state.max);
        } else {
            note.textContent = '';
        }
    }

    function premiumUrl() {
        var loc = window.__LOCALE || 'en';
        // /{loc}/pro на RU не существует (404); __PRO_URL знает дверь для гостя и для вошедшего.
        return window.__PRO_URL || ('/' + loc + '/pricing');
    }

    /* ── Выбор точки ───────────────────────────────────────────────────── */

    function setPicked(lat, lng, place) {
        picked = { lat: lat, lng: lng, place: place };
        var inp = $('qkWPlace');
        if (inp) inp.value = place;
    }

    function wireSearch() {
        var input = $('qkWPlace'), box = $('qkWSugg');
        if (!input || !box) return;
        var items = [], seq = 0;

        function close() { box.classList.remove('open'); box.innerHTML = ''; items = []; }

        input.addEventListener('input', function () {
            picked = null;                        // текст изменили — прежний выбор недействителен
            var q = input.value.trim();
            if (q.length < 2 || !window.LocationInput) { close(); return; }
            var mine = ++seq;
            /* ⚠️ searchWithFallback ВСЕГДА возвращает промис (на промахе
               подтягивает файл малых городов РФ), а search() отдаёт ССЫЛКИ на
               строки — {i, score, pop}, а не города. Обе ловушки уже стоили
               двум тулам-катаклизмам полностью неработающего поиска города,
               причём молча. */
            Promise.resolve(window.LocationInput.loadData())
                .then(function () {
                    return (window.LocationInput.searchWithFallback || window.LocationInput.search)(q, 7);
                })
                .then(function (hits) {
                    if (mine !== seq) return;      // человек уже дописал — ответ протух
                    items = (hits || []).map(function (h) { return window.LocationInput.rowToCity(h.i); });
                    if (!items.length) { close(); return; }
                    box.innerHTML = items.map(function (c, i) {
                        return '<button type="button" role="option" data-i="' + i + '">'
                             + esc(c.name) + '<small>' + esc(c.cc || '') + '</small></button>';
                    }).join('');
                    box.classList.add('open');
                })
                .catch(close);
        });

        box.addEventListener('click', function (e) {
            var b = e.target.closest('button[data-i]');
            if (!b) return;
            var c = items[+b.dataset.i];
            if (c) setPicked(c.lat, c.lng, c.name);
            close();
        });

        document.addEventListener('click', function (e) {
            if (!box.contains(e.target) && e.target !== input) close();
        });
    }

    function wireHere() {
        var btn = $('qkWHere');
        if (!btn) return;
        btn.addEventListener('click', function () {
            var geo = window.__geo;
            if (!geo) return;
            var pre = geo.available();
            if (!pre.ok) { window.__toast && window.__toast(geo.explain(pre.reason).text || tr('watch_error'), 'warning'); return; }
            geo.get({ enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 })
                .then(function (p) {
                    var lat = p.coords.latitude, lng = p.coords.longitude;
                    var coords = lat.toFixed(2) + ', ' + lng.toFixed(2);
                    // Имя точки — общий модуль GeoCity (public/js/geo-city.js):
                    // письмо должно говорить «рядом с Петропавловском», а не
                    // «рядом с 53.02», и на языке страницы, а не латиницей.
                    if (!window.GeoCity) { setPicked(lat, lng, coords); return; }
                    return window.GeoCity.lookup(lat, lng, { mode: 'near' }).then(function (it) {
                        setPicked(lat, lng, window.GeoCity.text(it) || coords);
                    });
                })
                .catch(function () { window.__toast && window.__toast(tr('watch_error'), 'warning'); });
        });
    }

    /* ── Запись и удаление ─────────────────────────────────────────────── */

    function wireAdd() {
        var btn = $('qkWAdd');
        if (!btn) return;
        btn.addEventListener('click', function () {
            if (!state.authed) { window.location.href = '/' + (window.__LOCALE || 'en') + '/login?redirect=' + encodeURIComponent(location.pathname); return; }
            if (!state.premium) { window.location.href = premiumUrl(); return; }
            if (!picked) { window.__toast && window.__toast(tr('watch_pick_first'), 'warning'); return; }

            btn.disabled = true;
            fetch(API, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrf(),
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                    lat: picked.lat, lng: picked.lng, place: picked.place,
                    radius_km: Number($('qkWRadius').value),
                    min_magnitude: Number($('qkWMag').value),
                    notify_tsunami: $('qkWTsunami').checked
                })
            })
                .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
                .then(function (res) {
                    if (!res.ok) {
                        // Отказ обязан быть НАЗВАН: молчащая кнопка — это тот
                        // самый «клик в пустоту», который потом ищут неделями.
                        var code = (res.d && res.d.error) || '';
                        if (code === 'premium_required') { window.location.href = premiumUrl(); return; }
                        var msg = code === 'watch_limit' ? tr('watch_limit').replace(':max', res.d.max)
                                : code === 'bad_settings' || code === 'invalid_point' ? tr('watch_bad')
                                : tr('watch_error');
                        window.__toast && window.__toast(msg, 'warning');
                        return;
                    }
                    state.watches.push(res.d.watch);
                    picked = null;
                    $('qkWPlace').value = '';
                    render();
                    window.__toast && window.__toast(tr('watch_added'), 'success');
                    ae('feature_use', { slug: 'earthquake-map', feature: 'watch_add' });
                })
                .catch(function () { window.__toast && window.__toast(tr('watch_error'), 'warning'); })
                .then(function () { btn.disabled = false; });
        });
    }

    function wireRemove() {
        var list = $('qkWList');
        if (!list) return;
        list.addEventListener('click', function (e) {
            var b = e.target.closest('button[data-del]');
            if (!b) return;
            var id = b.dataset.del;
            b.disabled = true;
            fetch(API + '/' + encodeURIComponent(id), {
                method: 'DELETE',
                credentials: 'same-origin',
                headers: { 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest' }
            })
                .then(function (r) {
                    if (!r.ok) throw new Error('http ' + r.status);
                    state.watches = state.watches.filter(function (w) { return String(w.id) !== String(id); });
                    render();
                })
                .catch(function () {
                    b.disabled = false;
                    window.__toast && window.__toast(tr('watch_error'), 'warning');
                });
        });
    }

    wireSearch();
    wireHere();
    wireAdd();
    wireRemove();
    load();
}());
